import type { Replacement, ReplacementsDict } from '../types/expert';
import { URL_REGEX } from './formatTextLinksForMarkdown';

export const testText =
  'Мы, *IT-компания NLabTeam**, написали MVP кроссплатформенного BI-приложения для HoReCa\
по референсу с использованием стека: Typescript, PostgreSQL, C#, C++, CSS, UI/UX.';

const escapeRegExp = (str: string): string => {
  // Экранируем все специальные символы в строке
  return str.replace(/[+#.*?^${}()|]/g, '\\$&');
};

const removeEmojis = (str: string) => {
  return str
    .replace(
      /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF]|\uFE0F|\uFE0E)/g,
      ''
    )
    .replace(/[\u200B-\u200D]/g, '');
};

const adaptTranscription = (transcription: string, voice: string) => {
  // меняем разметку для ударения от яндекса на форматы, воспринимаемые другими синтезами

  const accentPattern = /\+([аеёиоуыэюяАЕЁИОУЫЭЮЯ])/g;

  if (voice?.startsWith('google') || voice?.startsWith('elevenlabs')) {
    transcription = transcription.replace(accentPattern, (_, vowel) => vowel.toUpperCase());
  }

  return transcription;
};

const formatLinksForTTS = (text: string, voice: string) => {
  return (
    text
      // убираем форматирование ссылок, если оно есть
      .replace(/\[([^\]]+)\]\([^)]+\)/g, (_, linkText) => linkText)
      // ищем урлы
      .replace(URL_REGEX, (match) => {
        let result = match
          .replace(/^https?:\/\//, '')
          .replace(/-/g, ' дефис ')
          .replace(/\./g, ' точка ')
          .replace(/\//g, ' слэш ')
          .replace(/_/g, ' нижнее подчеркивание ')
          .replace(/ru/g, 'ру')
          // Убираем лишние пробелы
          .replace(/\s+/g, ' ')
          .trim();

        if (voice.startsWith('google') || voice.startsWith('elevenlabs')) {
          result = result.replace(/^www/, 'дабл-ю-дабл-ю-дабл-ю');
        }

        return result;
      })
  );
};

export const ttsTextPreprocessor = (
  text: string,
  caseSensitiveReplacements: Replacement[],
  caseInsensitiveReplacements: Replacement[],
  voice: string
) => {
  console.log('original: ', `"${text}"`);

  const caseSensitiveReplacementsDict: ReplacementsDict = {};

  caseSensitiveReplacements.forEach(([key, value]) => {
    if (key) {
      value = adaptTranscription(value, voice);
      caseSensitiveReplacementsDict[key] = value;
    }
  });

  const caseInsensitiveReplacementsDict: ReplacementsDict = {};

  caseInsensitiveReplacements.forEach(([key, value]) => {
    if (key) {
      value = adaptTranscription(value, voice);
      caseInsensitiveReplacementsDict[key.toLowerCase()] = value;
    }
  });

  // Регистрозависимая замена
  if (caseSensitiveReplacementsDict && Object.keys(caseSensitiveReplacementsDict).length) {
    // Экранируем все ключи из словаря
    const escapedKeys = Object.keys(caseSensitiveReplacementsDict).map(escapeRegExp);
    const caseSensitivePattern = new RegExp(`(${escapedKeys.join('|')})`, 'g');

    text = text.replace(caseSensitivePattern, (match) => caseSensitiveReplacementsDict[match]);
  }

  // Регистронезависимая замена
  if (caseInsensitiveReplacementsDict && Object.keys(caseInsensitiveReplacementsDict).length) {
    // Экранируем все ключи из словаря
    const escapedKeys = Object.keys(caseInsensitiveReplacementsDict).map(escapeRegExp);
    const caseInsensitivePattern = new RegExp(`(${escapedKeys.join('|')})`, 'gi');

    text = text.replace(
      caseInsensitivePattern,
      (match) => caseInsensitiveReplacementsDict[match.toLowerCase()]
    );
  }

  text = formatLinksForTTS(text, voice);

  text = removeEmojis(text).trim();

  console.log('preprocessed: ', `"${text}"`);

  return text;
};
